'use client';
var e, t;
function _define_property(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[t] = r, e;
}
function _object_spread(e) {
    for(var t = 1; t < arguments.length; t++){
        var r = null != arguments[t] ? arguments[t] : {}, n = Object.keys(r);
        "function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(r).filter(function(e) {
            return Object.getOwnPropertyDescriptor(r, e).enumerable;
        }))), n.forEach(function(t) {
            _define_property(e, t, r[t]);
        });
    }
    return e;
}
let r = {
    defaultMerge: Symbol("deepmerge-ts: default merge"),
    skip: Symbol("deepmerge-ts: skip")
}; ({
    defaultMerge: r.defaultMerge
});
function defaultMetaDataUpdater(e, t) {
    return t;
}
function defaultFilterValues(e, t) {
    return e.filter((e)=>void 0 !== e);
}
function getObjectType(e) {
    return "object" != typeof e || null === e ? 0 : Array.isArray(e) ? 2 : isRecord(e) ? 1 : e instanceof Set ? 3 : e instanceof Map ? 4 : 5;
}
function getKeys(e) {
    let t = new Set();
    for (let r of e)for (let e of [
        ...Object.keys(r),
        ...Object.getOwnPropertySymbols(r)
    ])t.add(e);
    return t;
}
function objectHasProperty(e, t) {
    return "object" == typeof e && Object.prototype.propertyIsEnumerable.call(e, t);
}
function getIterableOfIterables(e) {
    var t;
    let r = 0, n = null === (t = e[0]) || void 0 === t ? void 0 : t[Symbol.iterator]();
    return {
        [Symbol.iterator]: ()=>({
                next () {
                    for(;;){
                        if (void 0 === n) return {
                            done: true,
                            value: void 0
                        };
                        let o = n.next();
                        if (true === o.done) {
                            var t;
                            r += 1, n = null === (t = e[r]) || void 0 === t ? void 0 : t[Symbol.iterator]();
                            continue;
                        }
                        return {
                            done: false,
                            value: o.value
                        };
                    }
                }
            })
    };
}
(t = e || (e = {}))[t.NOT = 0] = "NOT", t[t.RECORD = 1] = "RECORD", t[t.ARRAY = 2] = "ARRAY", t[t.SET = 3] = "SET", t[t.MAP = 4] = "MAP", t[t.OTHER = 5] = "OTHER";
let o = [
    "[object Object]",
    "[object Module]"
];
function isRecord(e) {
    if (!o.includes(Object.prototype.toString.call(e))) return false;
    let { constructor: t } = e;
    if (void 0 === t) return true;
    let r = t.prototype;
    return !!(null !== r && "object" == typeof r && o.includes(Object.prototype.toString.call(r)) && r.hasOwnProperty("isPrototypeOf"));
}
let u = {
    mergeRecords: function(e, t, n) {
        let o = {};
        for (let u of getKeys(e)){
            let l = [];
            for (let t of e)objectHasProperty(t, u) && l.push(t[u]);
            if (0 === l.length) continue;
            let a = t.metaDataUpdater(n, {
                key: u,
                parents: e
            }), i = mergeUnknowns(l, t, a);
            i !== r.skip && ("__proto__" === u ? Object.defineProperty(o, u, {
                value: i,
                configurable: true,
                enumerable: true,
                writable: true
            }) : o[u] = i);
        }
        return o;
    },
    mergeArrays: function(e) {
        return e.flat();
    },
    mergeSets: function(e) {
        return new Set(getIterableOfIterables(e));
    },
    mergeMaps: function(e) {
        return new Map(getIterableOfIterables(e));
    },
    mergeOthers: function(e) {
        return e.at(-1);
    }
};
function deepmergeCustom(e, t) {
    let r = getUtils(e, customizedDeepmerge);
    function customizedDeepmerge(...e) {
        return mergeUnknowns(e, r, t);
    }
    return customizedDeepmerge;
}
function getUtils(e, t) {
    var n, o, l;
    return {
        defaultMergeFunctions: u,
        mergeFunctions: _object_spread({}, u, Object.fromEntries(Object.entries(e).filter(([e, t])=>Object.hasOwn(u, e)).map(([e, t])=>false === t ? [
                e,
                u.mergeOthers
            ] : [
                e,
                t
            ]))),
        metaDataUpdater: null !== (n = e.metaDataUpdater) && void 0 !== n ? n : defaultMetaDataUpdater,
        deepmerge: t,
        useImplicitDefaultMerging: null !== (o = e.enableImplicitDefaultMerging) && void 0 !== o && o,
        filterValues: false === e.filterValues ? void 0 : null !== (l = e.filterValues) && void 0 !== l ? l : defaultFilterValues,
        actions: r
    };
}
function mergeUnknowns(e, t, r) {
    var n, o;
    let u = null !== (o = null === (n = t.filterValues) || void 0 === n ? void 0 : n.call(t, e, r)) && void 0 !== o ? o : e;
    if (0 === u.length) return;
    if (1 === u.length) return mergeOthers(u, t, r);
    let l = getObjectType(u[0]);
    if (0 !== l && 5 !== l) {
        for(let e = 1; e < u.length; e++)if (getObjectType(u[e]) !== l) return mergeOthers(u, t, r);
    }
    switch(l){
        case 1:
            return mergeRecords(u, t, r);
        case 2:
            return mergeArrays(u, t, r);
        case 3:
            return mergeSets(u, t, r);
        case 4:
            return mergeMaps(u, t, r);
        default:
            return mergeOthers(u, t, r);
    }
}
function mergeRecords(e, t, n) {
    let o = t.mergeFunctions.mergeRecords(e, t, n);
    return o === r.defaultMerge || t.useImplicitDefaultMerging && void 0 === o && t.mergeFunctions.mergeRecords !== t.defaultMergeFunctions.mergeRecords ? t.defaultMergeFunctions.mergeRecords(e, t, n) : o;
}
function mergeArrays(e, t, n) {
    let o = t.mergeFunctions.mergeArrays(e, t, n);
    return o === r.defaultMerge || t.useImplicitDefaultMerging && void 0 === o && t.mergeFunctions.mergeArrays !== t.defaultMergeFunctions.mergeArrays ? t.defaultMergeFunctions.mergeArrays(e) : o;
}
function mergeSets(e, t, n) {
    let o = t.mergeFunctions.mergeSets(e, t, n);
    return o === r.defaultMerge || t.useImplicitDefaultMerging && void 0 === o && t.mergeFunctions.mergeSets !== t.defaultMergeFunctions.mergeSets ? t.defaultMergeFunctions.mergeSets(e) : o;
}
function mergeMaps(e, t, n) {
    let o = t.mergeFunctions.mergeMaps(e, t, n);
    return o === r.defaultMerge || t.useImplicitDefaultMerging && void 0 === o && t.mergeFunctions.mergeMaps !== t.defaultMergeFunctions.mergeMaps ? t.defaultMergeFunctions.mergeMaps(e) : o;
}
function mergeOthers(e, t, n) {
    let o = t.mergeFunctions.mergeOthers(e, t, n);
    return o === r.defaultMerge || t.useImplicitDefaultMerging && void 0 === o && t.mergeFunctions.mergeOthers !== t.defaultMergeFunctions.mergeOthers ? t.defaultMergeFunctions.mergeOthers(e) : o;
}

export { deepmergeCustom, getKeys, getObjectType, objectHasProperty };
